import type { FC } from 'react';

import { Box, Col, Image, Row, Text } from '@opendoor/bricks-next';

interface IHeaderProps {
  bathrooms?: number | null;
  bedrooms?: number | null;
  photo?: string | null;
  street?: string | null;
  sqft?: number | null;
  show: boolean;
}

/**
 * Showing request creation header
 *
 */
export const Header: FC<IHeaderProps> = ({
  bathrooms,
  bedrooms,
  photo,
  show,
  street,
  sqft,
}: IHeaderProps) => {
  if (!show) {
    return null;
  }

  return (
    <Box
      display="block"
      width="90%"
      py="$2x"
      mt="$2x"
      mb="$4x"
      $largerThanSM={{ p: '$8x', m: '$8x', mb: '$12x' }}
    >
      <Row>
        <Image
          alt="Property"
          height="$56x"
          width="$56x"
          source={{ uri: photo || undefined }}
          resizeMode="cover"
          borderRadius="$8x"
          $largerThanSM={{ ml: '$12x' }}
        />
        <Col ml="$8x">
          <Text tag="p" typography="$labelSmall">
            {street}
          </Text>
          <Text tag="p" typography="$bodySmall">
            {bedrooms} bd {bathrooms} ba, {sqft} sqft.{' '}
          </Text>
        </Col>
      </Row>
    </Box>
  );
};
